import { render } from "./EstateList.vue?vue&type=template&id=039c5f2c&scoped=true"
import script from "./EstateList.vue?vue&type=script&lang=js"
export * from "./EstateList.vue?vue&type=script&lang=js"

import "./EstateList.vue?vue&type=style&index=0&id=039c5f2c&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039c5f2c"]])

export default __exports__